import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/module.js'
import order from './order'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_logged: {},
    system_selected: {},
    export_item_master_to_excel: [],
    system_api: '',
    gentrade_customers: [],
    bundle_selection: [],
    dtpayload: {},
    data_table_items: [],
    new_data_store: false,
    _other:[]
  },
  getters: {
    GET_USER_LOGGED: (state) => state.user_logged,
    GET_EXPORT_ITEM_MASTER_TO_EXCEL: (state) => state.export_item_master_to_excel,
    GET_SYSTEM_API: (state) => state.system_api,
    GET_GENTRADE_CUSTOMERS: (state) => state.gentrade_customers,
    GET_BUNDLE_SELECTION: (state) => state.bundle_selection,
    GET_DATA_TABLE_ITEMS: (state) => state.data_table_items,
  },
  mutations: {
    USER_LOGGED: (state, data) => {
      state.user_logged = data;
    },
    SYSTEM_SELECTED: (state, data) => {
      state.system_selected = data;
    },
    EXP_ITEM_MASTER: (state, data) => { (state.export_item_master_to_excel = data) },
    GENTRADE_CUSTOMERS: (state, data) => { state.gentrade_customers },
    BUNDLE_SELECTION: (state) => { state.bundle_selection },
    DATA_TABLE_ITEMS: (state, data) => {
      state.data_table_items = data
    },
    NEW_DATA_STORE: (state, data) => {
      state.new_data_store = data
    },
    DTPAYLOAD: (state, data) => {
      state.dtpayload = data
    },
    _OTHER: (state, data) => {
      state._other = data
    }
  },
  actions: {
    login({ }, payload) {
      return new Promise((resolve, reject) => {
        api.login(payload).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    authentication({ }, payload) {
      return new Promise((resolve, reject) => {
        api.authentication(payload).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    SystemAuthentication({ }, payload) {
      return new Promise((resolve, reject) => {
        api.SystemAuthentication(payload).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getSystem({ }, payload) {
      return new Promise((resolve, reject) => {
        api.getSystem(payload).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    user_logged({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.user_logged(payload).then(response => {
          commit('USER_LOGGED', response.data)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    logout({ }, payload) {
      return new Promise((resolve, reject) => {
        api.logout(payload).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getDealerItems({ }, payload) {
      return new Promise((resolve, reject) => {
        api.getDealerItems(payload).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getItemTypes({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getitemtypes(payload).then((response) => {
          if (response.status == 200) {
            resolve(response.data)
          }
        }).catch((error) => {
          reject(error)
        });
      })
    },
    getitemcategories({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getitemcategories(payload).then((response) => {
          if (response.status == 200) {
            resolve(response.data)
          }
        }).catch((error) => {
          reject(error)
        });
      })
    },
    exportItemMasterToExcel({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.exportitemmastertoexcel(payload).then((response) => {
          if (response.status == 200) {
            resolve(response)
            commit('EXP_ITEM_MASTER', response.data)
          }
        }).catch((error) => {
          reject(error)
        });
      })
    },
    user_system_logged({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.user_system_logged(payload).then(response => {
          commit('USER_LOGGED', response.data)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    dealerLogin({ }, payload) {
      return new Promise((resolve, reject) => {
        api.dealerLogin(payload).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getGenTradeCustomers({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api
          .getgentradecustomers(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("GENTRADE_CUSTOMERS", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getBundles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getBundles(payload).then((response) => {
          commit("BUNDLE_SELECTION", response.data);
          resolve(response.data);
        }).catch((e) => {
          reject(e);
        });
      });
    },
    getitemsmodelid({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getitemsmodelid(payload).then((response) => {
          resolve(response)
        }).catch((e) => {
          reject(e);
        })
      })
    },
    showCustomers({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api
          .showcustomers(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCustomerPromoInfo({ commit }, payload) {
      let params = {
        promo_id: payload.promo_id,
        customer_id: payload.customer_id
      }
      return new Promise((resolve, reject) => {
        api.getcustomerpromoinfo(params).then((response) => {
          resolve(response)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getItemEditInfoshared({ commit }, payload) {
      let params = {
        promo_id: payload.promo_id,
        customer_id: payload.customer_id,
        model_id: payload.model_id,
        is_customer_order:payload.is_customer_order
      }
      return new Promise((resolve, reject) => {
        api.getItemEditInfoshared(params).then((response) => {
          resolve(response)
        }).catch((e) => {
          reject(e);
        })
      })
    },
    getItems({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getitems(payload).then((response) => {
          if (response.status == 200) {
            resolve(response)
          }
        }).catch((error) => {
          reject(error)
        });
      })
    },
    getDTItems({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getDTItems(payload).then((response) => {
          if (response.status == 200) {
            resolve(response.data)
          }
        }).catch((error) => {
          reject(error)
        });
      })
    },
    getItemsByModel({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api
          .getitemsbymodel(payload)
          .then(response => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    getBundledItems({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.getBundledItems(payload).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error);
        })
      })
    },
  },
  modules: {
    order
  }
})
